export type InsidePage = { image: string; alt: string };

export const insidePages: InsidePage[] = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/tY5zGZyu1CFfEPraxBCB5R/Captura_de_pantalla_2026-10-12_174532.png',
    alt: 'Página del Salmo 1: El camino que eliges define tu destino, con fragmento y explicación',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/4hEAe36XiNiW6viK7it1bf/Captura_de_pantalla_2026-10-12_174550.png',
    alt: 'Página del Salmo 23: Cuando necesitas paz y dirección, con oración guiada y aplicación diaria',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/f5rUXd6axBFy82xHiat6Dw/Captura_de_pantalla_2026-10-12_174619.png',
    alt: 'Página del Salmo 50: Cuando entiendes que Dios busca un corazón sincero, con oración guiada y reflexión final',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/hxYppfTAdNvcwak8NYbk1q/Captura_de_pantalla_2026-10-12_174639.png',
    alt: 'Página del Salmo 91: Cuando eliges habitar en la protección de Dios, con fragmento y explicación',
  },
];
